package de.oevbs.kunde.kundenportal2.components

import dev.fritz2.core.HtmlTag
import dev.fritz2.core.RenderContext
import org.w3c.dom.HTMLDivElement

fun RenderContext.paragraph(
    classes: String = "",
    content: HtmlTag<HTMLDivElement>.() -> Unit = {}
): HtmlTag<HTMLDivElement> = div("mt-1 mb-3 mx-0 w-full $classes") {
    content()
}

fun RenderContext.buttonContainer(content: RenderContext.() -> Unit) {
    div("w-full mt-5 p-0 justify-center md:justify-start flex flex-col md:flex-row gap-x-4 gap-y-2") {
        content()
    }
}

fun RenderContext.contentContainer(content: RenderContext.() -> Unit) {
    div("w-full py-2 grow flex flex-col gap-4 my-2 xl:my-10") {
        content()
    }
}
